import DOMPurify from 'dompurify'
import parse from 'html-react-parser'
export const convertHTMLToString = (HTMLText) => {
  const safeHTML = DOMPurify.sanitize(HTMLText)
  const content = parse(safeHTML)

  return content
}